class UserMentionManager {
  constructor() {
    if (UserMentionManager.instance) {
      return UserMentionManager.instance;
    }

    // Dictionnaires qui seront créés une seule fois
    this.usersById = {};
    this.usersByName = {};

    UserMentionManager.instance = this;
  }

  // Méthode pour initialiser les dictionnaires à partir des utilisateurs
  initialize(users) {
    if (Object.keys(this.usersById).length === 0 && users.length > 0) {
      this.usersById = users.reduce((acc, user) => {
        acc[user._id] = user.email.split('@')[0]; // Clé = _id, Valeur = nom
        return acc;
      }, {});

      this.usersByName = users.reduce((acc, user) => {
        const name = user.email.split('@')[0];
        acc[name] = user._id; // Clé = nom, Valeur = _id
        return acc;
      }, {});
    }
  }

  // Méthode pour remplacer les @IDMongoose par les noms d'utilisateur
  replaceIdsWithNames(content) {
    let modifiedContent = content;

    // Extraire les IDs @IDMongoose dans le contenu
    const userIds = Array.from(content.matchAll(/@([a-fA-F0-9]{24})/g)).map(
      (match) => match[1]
    );

    // Remplacer chaque ID par le nom d'utilisateur correspondant
    userIds.forEach((userId) => {
      if (this.usersById[userId]) {
        const mentionText = `@${this.usersById[userId]}`;
        const regex = new RegExp(`@${userId}`, 'g');
        modifiedContent = modifiedContent.replace(regex, mentionText);
      }
    });

    return modifiedContent;
  }

  // Méthode pour remplacer les @username par les IDs d'utilisateur
  replaceNamesWithIds(content) {
    let modifiedContent = content;

    // Extraire les noms @username dans le contenu
    const userNames = Array.from(content.matchAll(/@([a-zA-Z0-9._-]+)/g)).map(
      (match) => match[1]
    );

    // Remplacer chaque nom par l'ID de l'utilisateur correspondant
    userNames.forEach((name) => {
      if (this.usersByName[name]) {
        const regex = new RegExp(`@${name}`, 'g');
        modifiedContent = modifiedContent.replace(
          regex,
          `@${this.usersByName[name]}`
        );
      }
    });

    return modifiedContent;
  }
}

export default UserMentionManager;
